import config from "config/config";
export async function getUserProfile(
  UserName,
  Portal = "",
  ContractId = "",
  IdentityNumber = "",
  EmailAddress = "",
  UserId = 0,
  FirstName = "",
  LastName = "",
  MasterAgentId
) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  let queryString = "";
  if (UserName !== "") {
    queryString = "UserName=" + encodeURIComponent(UserName);
  } else if (ContractId !== "") {
    queryString = "ContractId=" + encodeURIComponent(ContractId);
  } else if (IdentityNumber !== "") {
    queryString =
      "IdentityNumber=" +
      encodeURIComponent(IdentityNumber) +
      "&FirstName=" +
      encodeURIComponent(FirstName) +
      "&LastName=" +
      encodeURIComponent(LastName);
  } else if (EmailAddress !== "") {
    queryString = "EmailAddress=" + encodeURIComponent(EmailAddress);
  } else if (UserId !== 0) {
    queryString = "UserId=" + UserId;
  }

  if (Portal !== "") {
    queryString = queryString + "&Portal=" + Portal;
  }

  if (MasterAgentId) {
    queryString = queryString + "&MasterAgentId=" + MasterAgentId;
  }

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/userprofile?" + queryString,
    options
  );

  if (!response.ok) {
    throw await response.json();
  } else {
    if (response.status === 204) {
      return null;
    } else {
      const data = await response.json();
      return data;
    }
  }
}
